<template>
  <div>
    <div style="padding-bottom: 90px">
      <div class="fixed-top py-3 bg-white shadow-sm">
        <div class="container text-center position-relative">
          <a href="javascript:" @click="$router.go(-1)" class="btn btn-outline-light position-absolute" style="left: 12px; top: -7px">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <div class="font-weight-bold">
            Perfil | Login
          </div>
        </div>
      </div>
    </div>

    <div class="mx-auto" style="padding-bottom: 45px; max-width: 400px">
      <div class="container">
        <form @submit.prevent="validate">
          <div class="form-group mb-2">
            <label class="mb-0 font-weight-bold small">Email ou Telefone *</label>
            <input type="text" class="form-control" placeholder="Seu endereço de email ou telefone" v-model="usuario.email" maxlength="100" required>
          </div>
          <div class="form-group mb-2">
            <label class="mb-0 font-weight-bold small">Senha *</label>
            <input type="password" class="form-control" placeholder="Senha" v-model="usuario.senha" maxlength="100" required>
          </div>
          <button class="btn btn-primary btn-block mb-2">
            <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
            <span v-show="!load">Entrar</span>
          </button>
        </form>
        <div class="mt-4 text-center">Ainda não é cadastrado? <router-link to="/perfil/cadastro" class="text-info">cadastrar</router-link></div>
        <div class="mt-2 text-center">Esqueceu sua senha? <router-link to="/perfil/esqueci-senha" class="text-info">recuperar</router-link></div>

        <div class="mt-4">
          <login-facebook str="Entrar com Facebook" hr="true"/>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import LoginFacebook from '../../../components/auth/LoginFacebook';

  export default {
    name: 'Login',
    components: { LoginFacebook },
    data() {
      return {
        token: localStorage.getItem('token'),
        load: false,
        usuario:  {
          email: '',
          senha: '',
          recaptcha: ''
        }
      }
    },

    methods: {
      logarUsuario() {
        this.load = true;
        this.$http.post(this.$store.state.base_url + 'login', this.usuario)
          .then(res => {

            if (res && res.data.success) {
              this.$emit('registrarLogin', res);
            }

            this.load = false;

          }, res => {
            console.log(res);
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      validate() {
        const regex = new RegExp('^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})|(^[0-9]{10})+$');

        if (this.usuario.email.trim() && !isNaN(this.usuario.email)) {
          if (this.usuario.email.length < 10 || this.usuario.email.length > 11) {
            this.$swal('Por favor, informe um telefone no formato válido (DDD + Número)');
            return;
          }

        } else if (!regex.test(this.usuario.email)) {
          this.$swal('Por favor, informe um e-mail ou telefone válido');
          return;
        }

        this.load = true;
        this.logarUsuario();
      }
    },

    created() {
      document.body.classList.remove("modal-open");
      sessionStorage.removeItem('edit_whatsapp');

      if (localStorage.getItem('token')) {
        this.$router.push('/home')
      }
    }
  }
</script>

<style scoped>

</style>
